import React from 'react';
import { Box, Button, Tab, Tabs } from '@leap4/frontend';
import { MuiIcons } from '@leap4/frontend';

const { BookmarkBorder, PlayArrow, Build, FolderOpen, VerifiedUser } = MuiIcons;

export type ReportTabValue = 'builder' | 'templates' | 'validation';

interface ReportHeaderProps {
  activeTab: ReportTabValue;
  onTabChange: (tab: ReportTabValue) => void;
  onSaveTemplate: () => void;
  onRunReport: () => void;
  isRunning: boolean;
}

export const ReportHeader: React.FC<ReportHeaderProps> = ({
  activeTab,
  onTabChange,
  onSaveTemplate,
  onRunReport,
  isRunning,
}) => {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        px: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Tabs
          value={activeTab}
          onChange={(_, value) => onTabChange(value)}
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: 14,
              minHeight: 56,
            },
          }}
        >
          <Tab label="Report Builder" value="builder" icon={<Build sx={{ fontSize: 18 }} />} iconPosition="start" />
          <Tab label="Templates" value="templates" icon={<FolderOpen sx={{ fontSize: 18 }} />} iconPosition="start" />
          <Tab label="Data Validation" value="validation" icon={<VerifiedUser sx={{ fontSize: 18 }} />} iconPosition="start" />
        </Tabs>
      </Box>

      {activeTab === 'builder' && (
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Button
            variant="outlined"
            startIcon={<BookmarkBorder />}
            onClick={onSaveTemplate}
          >
            Save Template
          </Button>
          <Button
            variant="contained"
            startIcon={<PlayArrow />}
            onClick={onRunReport}
            disabled={isRunning}
            sx={{
              background: 'linear-gradient(135deg, #1565c0, #1976d2)',
              boxShadow: '0 2px 8px rgba(25,118,210,0.35)',
            }}
          >
            {isRunning ? 'Running...' : 'Run Report'}
          </Button>
        </Box>
      )}
    </Box>
  );
};
